import classNames from "classnames";
import React from "react";
import styles from "./FloatingWindow.module.css";

interface FloatingWindowProps {
    className?: string;
    title?: string;
    action?: JSX.Element;
    children: React.ReactNode;
}

export default function FloatingWindow(props: FloatingWindowProps) {
    return (
        <div className={classNames(styles.container, props.className)}>
            <div className={styles.titleBar}>
                {props.title ?? ""}
                <div className={styles.action}>{props.action}</div>
            </div>
            <div className={styles.contents}>{props.children}</div>
        </div>
    );
}
